import React from "react";
import "./TextAreaStyle.css";

const TextArea = ({
  type,
  className,
  placeholder,
  id,
  labelName,
  checkBoxWrap,
  onChange,
  disabled,
  value,
  checked,
  isError,
  errorMessage,
  notImp,
  onKeyPress,
  blackLabel,
  name,
  rows,
}) => {
  return (
    <div className={`formGroups ${checkBoxWrap ?? ""}`}>
      <label className={blackLabel && "visible0"} htmlFor={id}>
        {labelName}
        {!notImp && <span className={"impRed"}> *</span>}
      </label>

      {/* <textarea /> */}

      <textarea
        className={className}
        placeholder={placeholder}
        rows={rows}
        type={type}
        // className={className}
        // placeholder={placeholder}
        onKeyPress={onKeyPress}
        disabled={disabled}
        value={value}
        onChange={onChange}
        id={id}
        checked={checked}
        name={name}
      />
      {errorMessage && <span className="FormError">{errorMessage}</span>}
    </div>
  );
};

export default TextArea;
